import { render, staticRenderFns } from "./FaqHeader.vue?vue&type=template&id=1f0fc8f8&scoped=true&"
import script from "./FaqHeader.vue?vue&type=script&lang=js&"
export * from "./FaqHeader.vue?vue&type=script&lang=js&"
import style0 from "./FaqHeader.vue?vue&type=style&index=0&id=1f0fc8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0fc8f8",
  null
  
)

export default component.exports